export function hashCode(value: string) {
  var hash = 5381,
    i = value.length;
  while (i) hash = (hash * 33) ^ value.charCodeAt(--i);
  return String(hash >>> 0);
}
